import ResetPassword from './reset_password';

export default ResetPassword;